import _sfc_main from "./FlowButton.vue2.js";
import _export_sfc from "../_virtual/_plugin-vue_export-helper.js";
const FlowButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-eee99524"]]);
export {
  FlowButton as default
};
//# sourceMappingURL=FlowButton.vue.js.map
